import type { Provider } from "../types/game";
import { rawgProvider } from "./rawg";
import { igdbProvider } from "./igdb";
import { steamProvider } from "./steam";

export const providers: Provider[] = [
  rawgProvider,
  igdbProvider,
  steamProvider,
];

export function getProvider(id: string): Provider {
  const p = providers.find((p) => p.id === id);
  if (!p) throw new Error(`Unknown provider: ${id}`);
  return p;
}
